export const typeOptions = [
  { label: '车位', value: 'CARPORT' },
  { label: '一卡通', value: 'CARD' },
  { label: '储物柜', value: 'CABINET' },
]



// WEBPACK FOOTER //
// ./src/page/none/workflow/not-house-input/forms/data/options.js